import { render } from "./RetirementCalculator.vue?vue&type=template&id=24a968e8"
import script from "./RetirementCalculator.vue?vue&type=script&lang=js"
export * from "./RetirementCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__